import type { ListingTrackingContext } from './types';

interface BuildCarouselTrackingContextInput {
	placement: string;
	/** Only `.length` is read. */
	properties: { length: number } | null | undefined;
	originProperty?: string | null;
}

// For static carousels (no filters, no pagination): `total === per_page`
// equals rendered cards so `positionInList + 1` matches the visual position.
export function buildCarouselTrackingContext(
	input: BuildCarouselTrackingContextInput
): ListingTrackingContext {
	const total = input.properties?.length ?? 0;

	return {
		placement: input.placement,
		origin_property: input.originProperty ?? null,
		applied_filters: {},
		total,
		page: 1,
		per_page: total
	};
}
